import React from 'react'
import '../MRUOutcomes/style.scss'

function MRUBobLearningOutcomesModal() {
	return (
		<div id="campus-life-modal" className="grid-12 c5 padd-top padd-bottom">
			<div className="span-12 padd-2 span-12-tablet">
				<div className="intro fs-125">
					<h2>
						End of Program <br />
						Student Learning Outcomes
					</h2>
				</div>
				<div className="grid-12 padd-top gap-1">
					<div className="container fs-85">
						<p className="padd-top">Upon completion of the program, students will be able to:</p>
						<ul>
							<li style={{ paddingBottom: '0.5rem' }}>
								Integrate knowledge of the core business concepts of accounting, finance, statistics,
								economics, management, and marketing to navigate challenges within the healthcare
								industry.
							</li>
							<li style={{ paddingBottom: '0.5rem' }}>
								Evaluate potential ethical and legal issues impacting the healthcare industry and make
								recommendations for appropriate course(s) of action.
							</li>
							<li style={{ paddingBottom: '0.5rem' }}>
								Demonstrate knowledge and understanding of information technology applications within the
								healthcare industry.
							</li>
							<li style={{ paddingBottom: '0.5rem' }}>
								Provide effective educational experiences leading to marketable graduates in the field of
								Healthcare specialization.
							</li>
							<li style={{ paddingBottom: '0.5rem' }}>
								Provide life-long experience to pursue opportunities for professional growth and
								development.
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	)
}

export default MRUBobLearningOutcomesModal
